import React from 'react';

import { Box, Typography } from '@mui/material';

import { parseNullableValue } from '@hrlogics/helper-utils';
import { SxProp } from '@hrlogics/react-helper-types';

import { DateFormatPatterns } from '@clearverify/constants';
import { formatDate } from '@clearverify/utils';

import { CompanyType } from 'src/api';
import { useEmployerById } from 'src/hooks/employer';

type EmployerControlledByInfoProps = {
  employerId?: string;
};

export const EmployerControlledByInfo: React.FC<EmployerControlledByInfoProps> = ({
  employerId,
}) => {
  const { employer } = useEmployerById(employerId);

  return (
    <Box sx={{ width: '100%', textAlign: 'center' }}>
      <Typography variant="body2" sx={typographyStyles}>
        Employer
      </Typography>

      {employer?.controlledBy === CompanyType.Peo && employer.peo && (
        <Typography variant="body2" sx={typographyStyles}>
          PEO: {parseNullableValue(employer.peo.displayName)}
        </Typography>
      )}

      {employer?.controlledBy === CompanyType.PeoPayrollProvider && employer.peoPayrollProvider && (
        <Typography variant="body2" sx={typographyStyles}>
          PEO PP: {parseNullableValue(employer.peoPayrollProvider.displayName)}
        </Typography>
      )}

      {employer?.createdAt ? (
        <Typography variant="body2" sx={typographyStyles}>
          Created at: {formatDate(employer.createdAt, DateFormatPatterns.shortDateWithSlash)}
        </Typography>
      ) : null}

      {employer?.setLiveAt ? (
        <Typography variant="body2" sx={typographyStyles}>
          Set live at: {formatDate(employer.setLiveAt, DateFormatPatterns.shortDateWithSlash)}
        </Typography>
      ) : null}
    </Box>
  );
};

const typographyStyles: SxProp = theme => ({
  color: theme.palette.text.secondary,
});
